import {getProperty} from "@/scripts/helpers/ObjectHelpers";

export default {
    getCanMakeInvoice(state) {
        return getProperty(state, 'can_make_invoice', false);
    }
}
